import { useContext, useEffect, useState } from "react";
import { RightsHolderMembershipStatusAndFee } from "../../../generated/data-contracts";
import { RightsHolderType } from "../../../models";
import { IAxiosError, api } from "../../../utils";
import { AvisForm } from "../../shared/components";
import {
  AvisDescriptiveText,
  AvisValueRow,
} from "../../shared/components/form";
import { AvisContext } from "../../shared/context/AvisContext";
import { ErrorLoadingDataHoc } from "../../shared/error/ErrorLoadingDataHoc";

export function MemberStatusPage() {
  const { res, ctxRightsHolder } = useContext(AvisContext);

  const [memberData, setMemberData] = useState<
    RightsHolderMembershipStatusAndFee | undefined
  >();
  const [isMemberStatusLoading, setIsMemberStatusLoading] =
    useState<boolean>(true);
  const [error, setError] = useState<IAxiosError>();

  const getData = () => {
    if (!ctxRightsHolder?.rightsHolderId) return;
    if (!isMemberStatusLoading) setIsMemberStatusLoading(true);

    api
      .rightsHoldersGetRightsHolderMembershipStatusAndFee(
        ctxRightsHolder.rightsHolderId,
      )
      .then((res) => setMemberData(res.data))
      .catch(setError)
      .finally(() => setIsMemberStatusLoading(false));
  };

  useEffect(() => {
    getData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ctxRightsHolder?.rightsHolderId]);

  const renderPage = () => {
    const memberFeeValue =
      memberData?.fee != undefined &&
      memberData?.fee != null &&
      ctxRightsHolder?.rightsHolderTypeCode == RightsHolderType.Author
        ? res("value_format_Eur", memberData.fee.toFixed(2))
        : res("message_NoData");
    return (
      <ErrorLoadingDataHoc error={error} loading={isMemberStatusLoading}>
        <div className="member-status-block">
          <AvisValueRow
            rowTitle={res("authors_MembersStatusPage_StatusLabel")}
            rowValue={memberData?.status}
          />
          <AvisValueRow
            rowTitle={res("authors_MembersStatusPage_FeeLabel")}
            rowValue={memberFeeValue}
          />
        </div>
      </ErrorLoadingDataHoc>
    );
  };

  return (
    <AvisForm title={res("authors_MemberStatusPage_Title")}>
      <AvisDescriptiveText textKey="portal_RH_MemberData_1" />
      {renderPage()}
      <AvisDescriptiveText textKey="portal_RH_MemberData_2" />
    </AvisForm>
  );
}
